import { Injectable } from '@angular/core';

import { combineLatest } from 'rxjs';
import { BenefitService } from './benefit.service';
import { mapTo } from 'rxjs/operators';
import { LoggingService } from '../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class BenefitResolver {
  constructor(private logService: LoggingService, private benefitService: BenefitService) {}

  resolve() {
    this.logService.info('Resolving benefits and claim limit');
    return combineLatest([this.benefitService.fetchBenefits(), this.benefitService.fetchLimit()]).pipe(mapTo(null));
  }
}
